@if (sidebarService.sections$ | async; as sidebarSections) {
  @if (breakpointService.deviceSize$ | async; as deviceSize) {
    <div
      tabindex="0"
      aria-expanded="false"
      class="sidebar"
      [ngClass]="{
        mobile: deviceSize.isMobile,
        'mobile-open': deviceSize.isMobile && sidebarService.forceExpand,
        'single-section': sidebarSections.length === 1,
        'multi-section': sidebarSections.length > 1,
      }"
    >
      <div class="sidebar-internal" tabindex="0" aria-expanded="false">
        @for (sidebarSection of mobileSizeMenu(sidebarSections, deviceSize.isMobile); track sidebarSection.title) {
          <mat-accordion>
            <mat-expansion-panel
              hideToggle
              [(expanded)]="sidebarSection.expanded"
              (opened)="expandSection(sidebarSection, sidebarSections)"
              (closed)="sidebarSection.expanded = false"
            >
              @if (sidebarSections.length > 1) {
                <mat-expansion-panel-header [ngClass]="{ 'selected-header': sidebarSection === chosenSection }">
                  <p id="sidebar-section-header">
                    <label for="">
                      <img
                        [alt]="sidebarSection.expanded ? 'Close Section' : 'Open Section'"
                        [src]="icon(sidebarSection)"
                      />
                      <span id="sidebar-section-title" class="flex-grow-1">{{ sidebarSection.title }}</span>
                    </label>
                    @if (sidebarSection.expanded) {
                      <img
                        id="close-button"
                        class="dropdown-button"
                        src="assets/glyphs/black/arrow_down.svg"
                        alt="Close button"
                        height="8"
                        width="8"
                      />
                    } @else {
                      <img
                        id="open-button"
                        class="dropdown-button"
                        src="assets/glyphs/black/chevron-right.svg"
                        alt="Open button"
                        height="8"
                        width="8"
                      />
                    }
                  </p>
                </mat-expansion-panel-header>
              }
              <ng-template matExpansionPanelContent>
                <div class="sidebar-section">
                  @for (sidebarItem of sidebarSection.items; track sidebarItemTrackBy($index, sidebarItem)) {
                    @if (sidebarItem.sidebarSubItem?.length || 0 > 0) {
                      <div
                        id="sidebar-section-item"
                        class="tree-toggle custom-row"
                        tabindex="0"
                        [attr.aria-expanded]="isItemExpanded(sidebarItem)"
                        (click)="toggleItem(sidebarItem)"
                        (keydown.enter)="toggleItem(sidebarItem)"
                      >
                        <img class="child-icon-size" [alt]="sidebarItem.title" [src]="sidebarItem.icon" />
                        <span id="sidebar-section-item-text" class="flex-grow-1">{{ sidebarItem.title }}</span>
                        <img
                          class="dropdown-button"
                          [src]="
                            isItemExpanded(sidebarItem)
                              ? 'assets/glyphs/black/arrow_down.svg'
                              : 'assets/glyphs/black/chevron-right.svg'
                          "
                          [alt]="isItemExpanded(sidebarItem) ? 'Close' : 'Open'"
                        />
                      </div>
                      @if (isItemExpanded(sidebarItem)) {
                        <div class="sidebar-tree-children">
                          @for (subItem of sidebarItem.sidebarSubItem; track subItem) {
                            @if (subItem.children?.length) {
                              <div
                                class="tree-toggle sub-level sub-section-bullet custom-row column-gap-small"
                                tabindex="0"
                                [attr.aria-expanded]="isSubItemExpanded(subItem)"
                                (click)="toggleSubItem(subItem)"
                                (keydown.enter)="toggleSubItem(subItem)"
                              >
                                <span class="flex-grow-1 f-12 fc-white">{{ subItem.title }}</span>
                                <img
                                  class="dropdown-button"
                                  [src]="
                                    isSubItemExpanded(subItem)
                                      ? 'assets/glyphs/black/arrow_down.svg'
                                      : 'assets/glyphs/black/chevron-right.svg'
                                  "
                                  [alt]="isSubItemExpanded(subItem) ? 'Close' : 'Open'"
                                />
                              </div>
                              @if (isSubItemExpanded(subItem)) {
                                <div class="sidebar-tree-grandchildren">
                                  @for (child of subItem.children; track child) {
                                    <div
                                      id="sidebar-section-item"
                                      class="sub-section-bullet"
                                      [ngClass]="{ selected: checkSidebarItem(child) }"
                                    >
                                      <a [routerLink]="child.routerLink ? child.routerLink() : null">
                                        <span class="f-12 fc-white">{{ child.title }}</span>
                                      </a>
                                    </div>
                                  }
                                </div>
                              }
                            } @else {
                              <div
                                id="sidebar-section-item"
                                class="sub-level sub-section-bullet custom-row column-gap-small ms-x-small"
                                [ngClass]="{ selected: checkSidebarItem(subItem) }"
                              >
                                <a [routerLink]="subItem.routerLink ? subItem.routerLink() : null">
                                  <span class="f-12 fc-white">{{ subItem.title }}</span>
                                </a>
                              </div>
                            }
                          }
                        </div>
                      }
                    } @else {
                      <div
                        id="sidebar-section-item"
                        [ngClass]="{
                          selected: checkSidebarItem(sidebarItem),
                        }"
                        (click)="sidebarItem.action?.(); setChosenSection(sidebarSection)"
                      >
                        <a
                          class="custom-row"
                          [routerLink]="sidebarItem.action ? null : sidebarItem?.routerLink() || null"
                        >
                          <img class="child-icon-size" [alt]="sidebarItem.title" [src]="sidebarItem.icon" />

                          <span id="sidebar-section-item-text">{{ sidebarItem.title }}</span>

                          @if (sidebarItem.showExternalLink) {
                            <img
                              alt="External Navigation Icon"
                              class="float-right"
                              src="assets/glyphs/black/share.svg"
                              id="sidebar-section-item-external-link"
                            />
                          }
                        </a>
                      </div>
                    }
                  }
                </div>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>
    </div>
  }
}
